import React, { useState } from 'react';

var urlParams = new URLSearchParams(window.location.search);
const username = urlParams.get("username");
const data_url = urlParams.get("data_url");
const content_type = urlParams.get("type");
const has_content = urlParams.get("has_content");
const backend_base = "https://speech-kws.ozonetel.com/ozosearch_backend";

function ResultList(props) {
    const results = props.results;
    const [showResults, setShowResults] = useState(false)
    const onClick = () => setShowResults(true)
    const r = results["result"];
    if (r) {
        if (props.content_type === 'document') {
            let listItems;
            if (props.has_content === 'true'){

            listItems = r.map((result) =>

                    <div className="searchresult" key={result[0].toString()}>
                        <h2>{result[0]}</h2>
                    <a href={result[1]}>{result[0]}</a>
                    <p>{result[2]}</p>
                    </div>

                );
            }else{
            listItems = r.map((result) =>
            
                <div className="searchresult" key={result[0].toString()}>
                    <h2>{result[0]}</h2>
                    <p>{result[2]}</p>
                </div>
            
            );
            }
            return (
                <div className="resultlist">
                    <ul><h2>Response:</h2><div>{results["chat"]}</div></ul>
                    <ul><input type="button" value="Know More" onClick={onClick} /></ul>
                    <ul>{showResults ? listItems : null}</ul>
                </div>
            );
        }
        else {
            const listItems = r.map((result) =>

                <div className="searchresult" key={result[0].toString()}>
                    <h2>{result[0]}</h2>
                    <a href={result[0]}>{result[0]}</a>
                    <p>{result[1]}</p>
                </div>

            );
            return (
                <div className="resultlist">
                    <ul><h2>Response:</h2><div>{results["chat"]}</div></ul>
                    <ul><input type="button" value="Know More" onClick={onClick} /></ul>
                    <ul>{showResults ? listItems : null}</ul>
                </div>
            );
        }
    }
    else {
        return (
            <div className="resultlist">

            </div>
        );
    }
}

//a search component that will take user input and pass to a REST API
class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = { value: '', results: [] };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) { this.setState({ value: event.target.value }); }
    handleSubmit(event) {

        // alert('A name was submitted: ' + this.state.value);
        const phrase_str = this.state.value;
        const content_type = urlParams.get("type");
	    const has_content = urlParams.get("has_content");


        /*make an asynch request to the server and store the json response in the state*/
        if (content_type !== 'document') {
            fetch(backend_base+"/websearch/?phrase=" + phrase_str + "&n=5&username=" + username + "&url_link=" + data_url)
                // fetch(api_url)

                .then(response => response.json())
                .then(data => this.setState({ results: data, content_type: content_type, has_content: has_content})

                );

            event.preventDefault();

        } else {
            fetch(backend_base+"/docsearch/?phrase=" + phrase_str + "&n=5&username=" + username + "&url_link=" + data_url)
                // fetch(api_url)

                .then(response => response.json())
                .then(data => this.setState({ results: data, content_type: content_type, has_content: has_content })

                );

            event.preventDefault();

        }
    }

    render() {
        return (

            <div className="search">
                <form className="example" onSubmit={this.handleSubmit}>
                    <input type="text" value={this.state.value} onChange={this.handleChange} placeholder="Got a question? Ask now" />
                    <button type="submit"><i class="fa fa-search"></i></button>
                </form>
                <ResultList results={this.state.results} content_type={this.state.content_type} has_content={this.state.has_content} />
            </div>

        );
    }
}

export default SearchBar;
